export default __webpack_public_path__ + "static/media/15 min.c195940d.svg";